'use client';

export { default } from './OutlinedInput';
export { default as outlinedInputClasses } from './outlinedInputClasses';
export * from './outlinedInputClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/OutlinedInput/index.js
// module id = 283
// module chunks = 22